import { Control, Controller } from 'react-hook-form'
import ProfileCoverPicture from '../ProfileCoverPicture'

interface Props {
  name: string
  control: Control
  required?: boolean
}

const FormCoverPicture = ({ name, control, required }: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field }) => <ProfileCoverPicture {...field} />}
    />
  )
}

export default FormCoverPicture
